import { useReducer } from "react";

import { ShowType } from "./context";

export const initial: State = {
	showType: "NO_AGREGATED",
	showTable: true
};

export interface State {
	showType: ShowType;
	showTable: boolean;
}

enum ActionType {
	onChangeShowType = "onChangeShowType",
	setShowTable = "setShowTable"
}

interface Action {
	type: string;
	val: ShowType | boolean;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.onChangeShowType:
			return { ...state, showType: action.val as ShowType };
		case ActionType.setShowTable:
			return { ...state, showTable: action.val as boolean };
		default:
			throw new Error();
	}
}

export default function useResultsActionsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		onChangeShowType: (val: ShowType) => dispatch({ type: ActionType.onChangeShowType, val }),
		setShowTable: (val: boolean) => dispatch({ type: ActionType.setShowTable, val })
	};

	return [state, actions] as const;
}
